import { useGroupStore } from "@/stores/groupStore";
import { useAuthStore } from "@/stores/authStore";
import { isCurrentUserGroupAdmin } from "@/lib/groupRoles";

/**
 * Returns whether the currently authenticated user is a group admin
 * (is_admin = true) in the active group.
 *
 * The list endpoint filters userRoles to the current user's entry only,
 * so userRoles[0] is always the current user's role.
 */
export function useGroupAdmin(): boolean {
  const activeGroup = useGroupStore((s) => s.activeGroup);
  const currentUserId = useAuthStore((s) => s.user?.id);
  return isCurrentUserGroupAdmin(activeGroup, currentUserId);
}
